import axios from 'axios';
import ApiURLs from '@/ApiURLs';
 
class LogService {
    sendLogToBackend(data: { message: string, stack?: string }) {
        const message = data.message ? data.message : data?.toString();
        const stack = data?.stack;

        return axios.post(ApiURLs.sendLogToBackend, { message: message, stack: stack });
    }
}

export default new LogService();